import * as Yup from "yup";

// required: Formik turns an empty field into undefined, and oneOf alone lets undefined through.
export function buildSetPasswordSchema(t) {
  return Yup.object({
    password: Yup.string()
      .required(t("validation.required")),
    confirmPassword: Yup.string().when("password", {
      is: val => (val && val.length > 0 ? true : false),
      then: Yup.string()
        .required(t("validation.required"))
        .oneOf([Yup.ref("password")], t("setPassword.doNotMatch"))
    })
  });
}
